import { ISection } from "../types/recommended-loans-types.types";
import { API_PATHS } from "../constants/api-paths";
import { createCacheAsync } from "@repo/shared-utils/cache";
import { IResponse, request } from "../core/api.client";

interface ICTAData {
  label: string;
  appLink: string;
  webLink: string;
}

export interface IProductFeature {
  image: string;
  label: string;
  description: string;
  drawerCtaText: string;
}

interface IProductDetails {
  label: string;
  images: string[];
  productFeatureVideo: string;
  productFeatureVideoThumbnailImage: string;
  productApplyVideo: string;
  productApplyVideoThumbnailImage: string;
  productDescription: string;
  featureIcons: IProductFeature[];
}

export interface ISKUApiResponse {
  skuId: string;
  category: string;
  subCategory: string;
  business: string;
  productCode: string;
  cardCode: string;
  productSkuLabel: string;
  amountPrefix: string;
  displayLoanAmount: string;
  loanAmountSuffix: string;
  actualLoanAmount: number;
  emiAmountText: string;
  emiAmount: number;
  tenure: number;
  tenureSuffix: string;
  roi: number;
  uspText: string;
  disbursalTime: number;
  cta: ICTAData;
  nudge1: string;
  nudge2: string;
  employmentType: string;
  loanType: string;
  variant: string;
  businessSegment: string;
  documentation: string;
  productDetails: IProductDetails;
  rating: number;
  sequence: number;
  clpSectionName: string;
  plpSectionName: string;
  msmeWorld: string;
  doctorWorld: string;
  relatedSkuDetails: ISection[];
}

export const getSKUDetails = async (
  skuId: string,
  productCategory: string
): Promise<IResponse<ISKUApiResponse>> => {
  try {
    const response = await createCacheAsync(
      `${API_PATHS.skuDetails}-${productCategory}-${skuId}`,
      request<ISKUApiResponse>,
      {
        method: "GET",
        url: `${API_PATHS.skuDetails}/${productCategory}/${skuId}`,
      }
    );
    return response;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
